var LeavesDisplayData = require("autograder/leaves.json");
var TagsDisplayData = require("autograder/tags.json");
var FiltersAndWarningsDisplayData = require("autograder/filters_and_warnings.json");
var CurrentUser = require("lib/account/CurrentUser");
var SkillsetData = require("autograder/skillsets.json");

export function getLeafName(key) {
	if (key in LeavesDisplayData) {
		return LeavesDisplayData[key]["Title"];
	}
}
export function getLeafDescription(key) {
	if (key in LeavesDisplayData) {
		return LeavesDisplayData[key]["Description"];
	}
}

export function getLeafOptions(key) {
	if (key in LeavesDisplayData) {
		if ("Options" in LeavesDisplayData[key])
		return LeavesDisplayData[key]["Options"].split(',');
	}
}

export function getLeafRubricKey(key) {
	if (key in LeavesDisplayData) {
		return LeavesDisplayData[key]["RubricKey"];
	}
}

export function getLeafAggregateKey(key) {
	if (key in LeavesDisplayData) {
		return LeavesDisplayData[key]["Aggregate"];
	}
}

export function sortLeaves(leaves) {
	var sortedLeaves = {}
	
	var sortedKeys = _.sortBy(_.keys(leaves), (l) => {
		if (!LeavesDisplayData[l] || !LeavesDisplayData[l].Order) {
			return 10000
		} else {
			return LeavesDisplayData[l].Order
		}
	})

	_.each(sortedKeys, (key) => {
		sortedLeaves[key] = leaves[key]
	})

	return sortedLeaves
}

export function getRubricLeaves(leaves, demo) {
	var output = {};
	_.each(RUBRIC_AGGREGATE_KEYS, (leafKey) => {
		var leafConfig = LeavesDisplayData[leafKey];

		if (!leafConfig || (leafConfig["Display"] != "True")) {
			return; // Skip to the next one
		}
		
		var useKey = leafConfig["RubricKey"] || leafKey;

		output[useKey] = output[useKey] || {
			values: [],
			labels: [],
			tag_keys: [],
			tags: [],
			rubric: false
		}

		if (leafConfig["Rubric"] && leafConfig["Rubric"] == "True") {
			output[useKey].rubric = true
		}

		var leafData = leaves[useKey]
		if (leafData) {
			if (CurrentUser.isPremiumOrTrialAccount() || demo) {
				var label = leafData.admin_label ? leafData.admin_label : leafData.label
			} else {
				var label = leafData.admin_label
			}
			output[useKey].labels.push(label)
			output[useKey].values.push(leafData.value);
			output[useKey].tag_keys = _.compact(output[useKey].tag_keys.concat(leafData.tag_keys));
			if (leafData.tags != undefined) {
				output[useKey].tags = _.compact(output[useKey].tags.concat(leafData.tags));
			}	
		}
	});

	_.each(output, (leafData, leafKey) => {
		if (leafData.rubric) {
			leafData.value = leafData.labels[0]
		} else {
			leafData.value = _.reduce(leafData.values, (memo, val) => memo + val) / leafData.values.length;
		}
	})

	return this.sortLeaves(output);
	
}

export function aggregateLeaves(leaves) {
	var output = {};
	_.each(leaves, (leafData, leafKey) => {
		var leafConfig = LeavesDisplayData[leafKey];

		if (!leafConfig || (leafConfig["Display"] != "True")) {
			return; // Skip to the next one
		}

		var useKey = leafConfig["Aggregate"] || leafKey;

		output[useKey] = output[useKey] || {
			values: [],
			labels: [],
			tag_keys: [],
			tags: [],
			rubric: false
		}

		if (leafConfig["Rubric"] && leafConfig["Rubric"] == "True") {
			output[useKey].rubric = true
		}

		output[useKey].values.push(leafData.value);
		output[useKey].labels.push(leafData.label)
		output[useKey].tag_keys = _.compact(output[useKey].tag_keys.concat(leafData.tag_keys));
		if (leafData.tags != undefined) {
			output[useKey].tags = _.compact(output[useKey].tags.concat(leafData.tags));
		}
	});

	_.each(output, (leafData, leafKey) => {
		if (leafData.rubric) {
			leafData.value = leafData.labels[0]
		} else {
			leafData.value = _.reduce(leafData.values, (memo, val) => memo + val) / leafData.values.length;
		}
	})

	return this.sortLeaves(output);
}

export function lookupSubstring(key) {
	return _.find(_.keys(TagsDisplayData), (k) => { return key.includes(k) })
}

export function isDisplayTag(key) {
	return key in TagsDisplayData || _.size(lookupSubstring(key))
}

export function shouldGroupTagSpans(key) {
	return (key in TagsDisplayData && TagsDisplayData[key]["GroupSpans"] != undefined);
}

export function groupTagSpans(tag) {
	var starts = _.map(tag.spans, (span) => span.start)
	var ends = _.map(tag.spans, (span) => span.end)
	starts.sort()
	ends.sort()
	return [{start: starts[0], end: ends[ends.length - 1]}]
}

export function getTagName(key) {
	if (isDisplayTag(key)) {
		var lookupKey = key in TagsDisplayData ? key : lookupSubstring(key)
		return TagsDisplayData[lookupKey]["Title"];
	}
}

export function getFilterOrWarningName(key) {
	if (key in FiltersAndWarningsDisplayData) {
		return FiltersAndWarningsDisplayData[key]["Title"];
	}
}

export function isLeafPostQuizFeedback(key) {
	if (key in LeavesDisplayData) {
		return LeavesDisplayData[key]["PostQuizFeedbackTitle"] != undefined
	} else {
		return false
	}
}

export function getLeafPostQuizFeedback(key,isPositive) {
	var title = LeavesDisplayData[key]["PostQuizFeedbackTitle"]

	if (isPositive) {
		var description = LeavesDisplayData[key]["PositivePostQuizFeedback"]
	} else {
		var description = LeavesDisplayData[key]["NegativePostQuizFeedback"]
	}
	return {title: title, description: description}
}

export function getFilterPostQuizFeedback(key) {
	var title = FiltersAndWarningsDisplayData[key]["PostQuizFeedbackTitle"]
	var description = FiltersAndWarningsDisplayData[key]["NegativePostQuizFeedback"]
	return {title: title, description: description}
}

export function leafValueToScore(value) {
	if (value >= 0.6) {
		return 4
	} else if (value >= 0.5) {
		return 3;
	} else if (value >= 0.25) {
		return 2;
	} else {
		return 1;
	}
}

export function getScoringDisplayRequirement(value) {
	if (value >= 0.8) {
		return 0
	} else if (value >= 0.6) {
		return 1
	} else {
		return 2
	}
}

export function leafValueToText(value, requirement) {
	var text = "High"
	if (value <= 0.5) {
		text = "Low"
	} else if (value <= 0.7) {
		text = "Average"
	}
	if (requirement > 0 && text != "Low") {
		return "Average"
	}
	return text
}

export var LEAF_SCORE_CAP = 4;

// flags FE to add 'New' label
export var NEW_KEYS = ['aggregate-restated']
// flags FE to add 'Beta' label
export var BETA_KEYS = ['crit-rc-atq-coqa-fully-answered-2']

// rubric keys
export var RUBRIC_AGGREGATE_KEYS = [
	"aggregate-read-book",
	"aggregate-fully-answered-question",
	"aggregate-answer-length",
	"aggregate-text-details-count",
	"aggregate-restated",
	// "aggregate-sentence-structure",
	"aggregate-capitalization",
	"aggregate-punctuation",
	"aggregate-spelling",
	"aggregate-grammar",
	"aggregate-word-count",
	"aggregate-sentence-count"]

export var POLARIZING_KEY_TO_RUBRIC_KEY = {
	"crit-evi-cote-bert-read-book-1": "01_TEXT-SPE_read-the-book",
	"crit-rc-atq-coqa-fully-answered-2": "02_READ-COMP_fully-answered",
	"03_READ-COMP_answer-present": "03_READ-COMP_answer-present",
	"comm-conv-mech-caps-4": "04_MECH_capitalization",
	"comm-conv-mech-gram-5": "05_MECH_grammar",
	"06_MECH_introduction": "06_MECH_introduction",
	"07_MECH_ling-accpt": "07_MECH_ling-accpt",
	"comm-conv-mech-punc-8": "08_MECH_punct",
	"09_MECH_repetitions": "09_MECH_repetitions",
	"crit-rc-atq-cors-bert-10": "10_READ-COMP_restating",
	"comm-conv-org-sent-count-11": "11_LEN_sent-count",
	"comm-conv-org-sent-struct-coso-12": "12_MECH_sent-struct",
	"comm-conv-mech-spell-13": "13_MECH_spelling",
	"crit-evi-cote-bert-quantity-14": "14_TEXT-SPE_text-details-count",
	"15_MECH_transition": "15_MECH_transition",
	"16_VOC_complex-vocab": "16_VOC_complex-vocab",
	"17_TEXT-SPE_text-details-qual": "17_TEXT-SPE_text-details-qual",
	"comm-conv-org-word-count-18": "18_LEN_sent-count"
}

export var SUCCESS_OUTPUT = ['Yes', 'Sufficient', 'Correct', 'Solid', 'Complete']
export var MIDDLING_OUTPUT = ['Partial', 'Developing']
export var FAIL_OUTPUT = ['No', 'Insufficient', 'No structure', 'No Structure', 'None', 'Incorrect', 'Incomplete']


// WEBPACK FOOTER //
// ./modules/lib/interface/AutograderDisplayConfig.js